import { render, staticRenderFns } from "./EinstellungenAnmeldungen.vue?vue&type=template&id=5bd3f9ba&"
import script from "./EinstellungenAnmeldungen.vue?vue&type=script&lang=js&"
export * from "./EinstellungenAnmeldungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports